import {Action} from '@ngrx/store';
import {type} from '../utilities/type';
import {ContractLinkSummaries} from '../models/contract-link';

export const linkContractActionTypes = {
  LOAD: type('[Link Contract] Load'),
  UPDATE_COMPANY_NAME: type('[Link Contract] Update name'),
  LOAD_SUCCESS: type('[Link Contract] Load Success'),
  LOAD_FAIL: type('[Link Contract] Load Fail')
};

export class LoadLinkContractAction implements Action {
  readonly type = linkContractActionTypes.LOAD;
  constructor(public payload?: Object) {}
}
export class LoadLinkContractUpdateCompanyNameAction implements Action {
  readonly type = linkContractActionTypes.UPDATE_COMPANY_NAME;
  constructor(public payload?: string) {}
}


export class LoadLinkContractSuccessAction implements Action {
  readonly type = linkContractActionTypes.LOAD_SUCCESS;
  constructor(public payload?:  ContractLinkSummaries []) {}
}

export class LoadLinkContractFailAction implements Action {
  readonly type = linkContractActionTypes.LOAD_FAIL;
  constructor(public payload?: string) {}
}
